var _objectWithoutProperties = require("/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _objectSpread = require("/node_modules/@babel/runtime/helpers/objectSpread");

var _extends2 = require("/node_modules/@babel/runtime/helpers/extends");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  max-width: 1400px;\n  margin: auto;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: contents;\n  &.left {\n    display: flex;\n    flex-flow: row-reverse;\n    > * {\n      padding-right: 20px;\n    }\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  position: sticky;\n  top: ", ";\n  width: 100%;\n  z-index: 9999;\n  background: white;\n  @media (max-width: ", "em) {\n    top: ", ";\n  }\n  @media (max-width: ", "em) {\n    top: ", ";\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  width: 1216px;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 20px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  /* FIXME: this is overridden here due to the mockup */\n  button {\n    padding: 18px 14px;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: block;\n  text-transform: uppercase;\n\n  &:hover {\n    background: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 5px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  white-space: pre;\n  padding: 0 10px;\n  text-transform: uppercase;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  transition: all 0.3s ease;\n  top: 0;\n  bottom: 0;\n  max-width: 80%;\n  width: 330px;\n  z-index: 4000;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  background: black;\n  opacity: 0.25;\n  z-index: 3000;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 10000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: block;\n  text-transform: uppercase;\n  text-decoration: none;\n\n  &:hover {\n    background: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('styled-components'), require('react-dom'), require('prop-types'), require('is-react'), require('@rtm-ui/layout'), require('@rtm-ui/icon'), require('@rtm-ui/button'), require('@rtm-ui/a'), require('@rtm-ui/typography'), require('@rtm-ui/theme')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'styled-components', 'react-dom', 'prop-types', 'is-react', '@rtm-ui/layout', '@rtm-ui/icon', '@rtm-ui/button', '@rtm-ui/a', '@rtm-ui/typography', '@rtm-ui/theme'], factory) : (global = global || self, factory(global.nav = {}, global.React, global.styled, global.ReactDom, global.PropTypes, global.IsReact, global.RtmUiLayout, global.RtmUiIcon, global.RtmUiButton, global.RtmUiA, global.RtmUiTypography, global.RtmUiTheme));
})(this, function (exports, React, styled, ReactDOM, PropTypes, isReact, layout, icon, button, a, typography, theme) {
  'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  var styled__default = 'default' in styled ? styled['default'] : styled;
  ReactDOM = ReactDOM && Object.prototype.hasOwnProperty.call(ReactDOM, 'default') ? ReactDOM['default'] : ReactDOM;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;
  isReact = isReact && Object.prototype.hasOwnProperty.call(isReact, 'default') ? isReact['default'] : isReact;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function useWindowSize() {
    function getSize() {
      /* istanbul ignore else */
      if (typeof window !== 'undefined') {
        return {
          width: window.innerWidth,
          height: window.innerHeight
        };
      } else {
        return {
          width: 0,
          height: 0
        };
      }
    }

    var _React$useState = React.useState(getSize),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        windowSize = _React$useState2[0],
        setWindowSize = _React$useState2[1];

    React.useEffect(function () {
      function handleResize() {
        setWindowSize(getSize());
      }

      window.addEventListener('resize', handleResize);
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }, []); // Empty array ensures that effect is only run on mount and unmount

    return windowSize;
  }

  var A = styled__default.a(_templateObject(), function (props) {
    return theme.getColor('light', props.theme);
  });
  var SheetItem = styled__default(layout.Box)(_templateObject2(), function (props) {
    return theme.getColor('background', props.theme);
  });
  var Wrapper = styled__default.div(_templateObject3());
  var ScreenWrapper = styled__default.div(_templateObject4());
  var SheetWrapper = styled__default(layout.Pane)(_templateObject5());

  var Screen = function Screen(props) {
    return (
      /*#__PURE__*/
      React__default.createElement(ScreenWrapper, {
        onClick: props.onClick
      })
    );
  };

  var Sheet = function Sheet(props) {
    var isClosed = props.isClosed,
        toggle = props.toggle;
    var items = props.items.map(function (_ref) {
      var item = _extends2({}, _ref);

      if (item.scrollTo) {
        item = _objectSpread({}, item, {
          onClick: function onClick(e) {
            layout.scrollToElement(e, item.scrollTo);
          }
        });
      }

      return _objectSpread({}, item);
    });
    return (
      /*#__PURE__*/
      React__default.createElement(Wrapper, {
        isClosed: isClosed
      },
      /*#__PURE__*/
      React__default.createElement(Screen, {
        "data-testid": "nav-screen",
        onClick: toggle
      }),
      /*#__PURE__*/
      React__default.createElement(SheetWrapper, {
        variant: "a",
        elevation: 2
      },
      /*#__PURE__*/
      React__default.createElement(SheetItem, {
        p: 20
      }, typeof props.headerAction === 'function' && props.headerAction(toggle),
      /*#__PURE__*/
      React__default.createElement(A, {
        "data-testid": "toggle-close-nav",
        onClick: toggle
      },
      /*#__PURE__*/
      React__default.createElement(layout.Box, null,
      /*#__PURE__*/
      React__default.createElement(icon.Icon, {
        size: 40,
        fill: "primary",
        glyph: "view-close"
      })))), items.filter(function (item) {
        return props.isDesktop && !item.navbar || !props.isDesktop;
      }).map(function (_ref2) {
        var id = _ref2.id,
            href = _ref2.href,
            label = _ref2.label,
            _ref2$onClick = _ref2.onClick,
            onClick = _ref2$onClick === void 0 ? null : _ref2$onClick;
        var clickProps = onClick ? {
          key: id,
          onClick: onClick
        } : {
          key: id,
          href: href
        };
        return (
          /*#__PURE__*/
          React__default.createElement(A, clickProps,
          /*#__PURE__*/
          React__default.createElement(SheetItem, {
            p: 20
          },
          /*#__PURE__*/
          React__default.createElement(typography.Header, {
            style: {
              lineHeight: '2'
            },
            tag: "h6"
          }, label),
          /*#__PURE__*/
          React__default.createElement(layout.Box, null,
          /*#__PURE__*/
          React__default.createElement(icon.Icon, {
            fill: "primary",
            size: 40,
            inline: true,
            glyph: "view-forward"
          }))))
        );
      })))
    );
  };

  Screen.propTypes = {
    onClick: PropTypes.func,
    isClosed: PropTypes.bool
  };
  Sheet.defaultProps = {
    isClosed: true
  };
  Sheet.propTypes = {
    isClosed: PropTypes.bool,
    headerAction: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func,
      label: PropTypes.string
    })),
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
  };
  var NavA = styled__default(a.A)(_templateObject6());
  var LogoA = styled__default(a.A)(_templateObject7());

  var ProfileStatus = function ProfileStatus(_ref3) {
    var user = _ref3.user,
        signOutPath = _ref3.signOutPath,
        signInPath = _ref3.signInPath,
        signOutText = _ref3.signOutText,
        signInText = _ref3.signInText;
    return user ?
    /*#__PURE__*/
    React__default.createElement(layout.Box, {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    },
    /*#__PURE__*/
    React__default.createElement(icon.Icon, {
      fill: "tertiary",
      glyph: "profile"
    }),
    /*#__PURE__*/
    React__default.createElement(layout.Box, {
      pl: 10,
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }
    },
    /*#__PURE__*/
    React__default.createElement(typography.Small, {
      color: "primary"
    }, user.email),
    /*#__PURE__*/
    React__default.createElement(button.Button, {
      "data-testid": "sign-out",
      as: "a",
      asWrapper: true,
      href: signOutPath
    },
    /*#__PURE__*/
    React__default.createElement(typography.Header, {
      tag: "h6"
    }, signOutText || 'SIGN OUT')))) :
    /*#__PURE__*/
    React__default.createElement(button.Button, {
      "data-testid": "sign-in",
      as: "a",
      href: signInPath
    }, signInText || 'Sign Up');
  };

  var StyledParagraph = styled__default(typography.Paragraph)(_templateObject8(), function (props) {
    return props.showHover && '#eee';
  });
  var Flex = styled__default(layout.Pane)(_templateObject9());
  var NavList = styled__default(layout.Box)(_templateObject10());
  var ToggleList = styled__default(layout.Box)(_templateObject11());
  var NoToggleList = styled__default(layout.Box)(_templateObject12());
  var NavGroup = styled__default(layout.Box)(_templateObject13());
  var NavGroupWrapper = styled__default(NavGroup)(_templateObject14());
  var FixedPosition = styled__default.div(_templateObject15(), function (props) {
    return props.withCookieBanner ? '36px' : 0;
  }, function (props) {
    return props.theme.grid.md;
  }, function (props) {
    return props.withCookieBanner ? '50px' : 0;
  }, function (props) {
    return props.theme.grid.sm;
  }, function (props) {
    return props.withCookieBanner ? '70px' : 0;
  });
  var StyledNavbar = styled__default(Flex)(_templateObject16(), function (props) {
    return props.sticky ? 'none' : 'inherit';
  });
  var BrandItems = styled__default(layout.Box)(_templateObject17());

  var Navbar = function Navbar(_ref4) {
    var variant = _ref4.variant,
        props = _objectWithoutProperties(_ref4, ["variant"]);

    var _React__default$useCo = React__default.useContext(styled.ThemeContext),
        logoGlyph = _React__default$useCo.logoGlyph;

    return (
      /*#__PURE__*/
      React__default.createElement(StyledNavbar, {
        variant: variant,
        px: [10, 20],
        py: [0, 0, 0, 10],
        elevation: 1
      }, props.isDesktop &&
      /*#__PURE__*/
      React__default.createElement("div", {
        style: {
          wdith: '32px'
        }
      }),
      /*#__PURE__*/
      React__default.createElement(NavGroupWrapper, {
        px: [0, 0, 32]
      },
      /*#__PURE__*/
      React__default.createElement(BrandItems, {
        "data-testid": "brand-items",
        className: props.logoPosition
      }, props.isDesktop && props.tagline &&
      /*#__PURE__*/
      React__default.createElement(typography.Paragraph, {
        pr: 10,
        weight: "bold",
        color: "tertiary",
        tag: "h6"
      }, props.tagline),
      /*#__PURE__*/
      React__default.createElement(layout.Box, {
        style: {
          display: 'flex'
        }
      },
      /*#__PURE__*/
      React__default.createElement(LogoA, {
        href: "/"
      }, isReact.compatible(props.logo) ? props.logo :
      /*#__PURE__*/
      React__default.createElement(icon.Logo, {
        entityBrand: logoGlyph,
        width: props.isDesktop ? 150 : 100
      })))),
      /*#__PURE__*/
      React__default.createElement(NavList, null, props.isDesktop ?
      /*#__PURE__*/
      React__default.createElement(NavGroup, null, props.items.filter(function (item) {
        return item.navbar;
      }).map(function (_ref5) {
        var label = _ref5.label,
            id = _ref5.id,
            item = _objectWithoutProperties(_ref5, ["label", "id"]);

        if (item.scrollTo) {
          item = _objectSpread({}, item, {
            onClick: function onClick(e) {
              layout.scrollToElement(e, item.scrollTo);
            }
          });
        }

        return (
          /*#__PURE__*/
          React__default.createElement(NavA, _extends({
            key: id,
            color: "primary",
            weight: "bold"
          }, item), label)
        );
      })) :
      /*#__PURE__*/
      React__default.createElement("div", null))), props.isDesktop && props.showSideNav || !props.isDesktop ?
      /*#__PURE__*/
      React__default.createElement(ToggleList, {
        p: 10
      }, props.children,
      /*#__PURE__*/
      React__default.createElement(a.A, {
        onClick: function onClick() {
          return props.onNavClick();
        }
      },
      /*#__PURE__*/
      React__default.createElement(StyledParagraph, {
        ml: "5px",
        showHover: true,
        "data-testid": "toggle-nav"
      },
      /*#__PURE__*/
      React__default.createElement(icon.Icon, {
        size: 48,
        fill: "primary",
        glyph: "menu"
      })))) :
      /*#__PURE__*/
      React__default.createElement(NoToggleList, null))
    );
  };

  var Portal = function Portal(props) {
    return (
      /*#__PURE__*/
      ReactDOM.createPortal(
      /*#__PURE__*/
      React__default.createElement(Sheet, _extends({
        headerAction: props.header
      }, props)), document.body)
    );
  };

  var SubHeaderWrapper = styled__default(layout.Box)(_templateObject18());

  var NavbarPositioner = function NavbarPositioner(props) {
    if (props.sticky) {
      return (
        /*#__PURE__*/
        React__default.createElement(FixedPosition, {
          "data-testid": "nav-fixed",
          withCookieBanner: props.withCookieBanner
        }, props.children)
      );
    } else {
      return (
        /*#__PURE__*/
        React__default.createElement(React__default.Fragment, null, props.children)
      );
    }
  };

  var Nav = function Nav(props) {
    var size = useWindowSize();

    var _React__default$useSt = React__default.useState(),
        _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
        isDesktop = _React__default$useSt2[0],
        setIsDesktop = _React__default$useSt2[1];

    React__default.useLayoutEffect(function () {
      setIsDesktop(size.width > 1300);
    }, [size.width]);

    var _React__default$useSt3 = React__default.useState(true),
        _React__default$useSt4 = _slicedToArray(_React__default$useSt3, 2),
        isClosed = _React__default$useSt4[0],
        toggleClosed = _React__default$useSt4[1];

    var toggle = function toggle() {
      return toggleClosed(!isClosed);
    };

    return (
      /*#__PURE__*/
      React__default.createElement(NavbarPositioner, {
        sticky: props.sticky,
        withCookieBanner: props.withCookieBanner
      },
      /*#__PURE__*/
      React__default.createElement(Navbar, {
        showSideNav: props.user !== null || props.items.some(function (i) {
          return i.navbar !== true;
        }),
        sticky: props.sticky,
        variant: props.variant,
        isDesktop: isDesktop,
        logoPosition: props.logoPosition,
        logo: props.logo,
        onHomeClick: props.onHomeClick,
        tagline: props.tagline,
        onNavClick: toggle,
        items: props.items
      }, !props.user && props.children), props.subHeader &&
      /*#__PURE__*/
      React__default.createElement(layout.Box, {
        variant: "b"
      },
      /*#__PURE__*/
      React__default.createElement(SubHeaderWrapper, null,
      /*#__PURE__*/
      React__default.createElement(typography.Header, {
        tag: "h6",
        p: "5px",
        pl: "10px",
        align: "center",
        weight: "bold"
      }, props.subHeader))), !isClosed &&
      /*#__PURE__*/
      React__default.createElement(Portal, _extends({}, props, {
        header: function header() {
          return props.signOutPath &&
          /*#__PURE__*/
          React__default.createElement(ProfileStatus, {
            user: props.user,
            signInPath: props.signInPath,
            signOutPath: props.signOutPath,
            signOutText: props.signOutText,
            signInText: props.signInText
          });
        },
        isDesktop: isDesktop,
        isClosed: isClosed,
        toggle: toggle
      })))
    );
  };

  Nav.propTypes = {
    logo: PropTypes.string,
    sticky: PropTypes.bool,
    onHomeClick: PropTypes.func,
    logoPosition: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func,
      label: PropTypes.string,
      scrollTo: PropTypes.string
    })),
    children: PropTypes.node
  };
  Nav.defaultProps = {
    logoPosition: 'left'
  };
  Navbar.propTypes = {
    logo: PropTypes.string,
    showSideNav: PropTypes.bool,
    desktop: PropTypes.bool,
    logoPosition: PropTypes.string,
    onHomeClick: PropTypes.func,
    onNavClick: PropTypes.func
  };
  exports.Nav = Nav;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});